// CustomModal.tsx
import React from "react";
import { Modal, Box, Typography, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

interface CustomModalProps {
  open: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
  width?: number | string;
  maxHeight?: string;
}

const modalStyle = {
  position: "absolute" as const,
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  overflowY: "auto" as const,
  p: 4,
};

export const CustomModal: React.FC<CustomModalProps> = ({
  open,
  onClose,
  title,
  children,
  width = 900,
  maxHeight = "80vh",
}) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
    >
      <Box sx={{ ...modalStyle, width, maxHeight }}>
        <Typography
          variant="h4"
          gutterBottom
          justifyContent="space-between"
          alignItems="center"
          display="flex"
          id="modal-title"
        >
          {title}
          <IconButton aria-label="close" onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Typography>
        {children}
      </Box>
    </Modal>
  );
};
